$(document).ready( function () {

  var $carousel = $('.carousel').flickity({
    // options
    wrapAround: true,
    autoPlay: false,
    imagesLoaded: true,
    lazyLoad: true
  });  
  
  var $featurecarousel = $('.main-carousel').flickity();

  $('.button--next').on( 'click', function() {
    $featurecarousel.flickity('next');
  });  

  $('.button--previous').on( 'click', function() {
    $featurecarousel.flickity('previous');
  }); 

  $('.block-content-intro a').on( 'click', function() {
  
      $(this).addClass('hide');
      $(this).parent().parent().find('.block-content-description p').show('slow');
  
    
  });  


  $('.m-product-option--content .m-product-option--node__label').on( 'click', showLayout1Gallery);
  $('.m-product-option--content .product-option-item').on( 'click', showLayout1Gallery);
  
    function showLayout1Gallery(){
        $('.m-product-option--node input:checked').each(i => {
            const selected_variant = $(this).parent().attr('data-value');
            const selected_attribute = `[data-gallery-alt="${selected_variant}"]`; 
            if($(selected_attribute).length){
                $(selected_attribute).removeClass('hidden').siblings().addClass('hidden');
                $carousel.flickity('resize');
            }
        })
    }
  
  $('[data-product-id="8978398871769"] .js.variant-picker__input.variant-picker__button').append('<div class="flex items-center ml-2 mt-2"><a href="/products/kiwi-ears-allegro-mini" target="_blank" class="inline-block sf__btn sf__btn-link slide__block-link">Allegro Mini Description</a></div>')
} );
